/* eslint-disable no-param-reassign */
export default {
    SET_FILTER_OPTION({ filterOption }, payload) {
        Object.entries(payload).forEach(([key, value,]) => {
            filterOption[key] = value;
        });
    },
    GET_HUB_INFO(state, payload) {
        state.hubInfo = payload;
    },
    GET_WITHHOLD_TAX(state, payload) {
        state.withholdTaxInfo = payload;
    },
};
